import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckSquare, Send, FileSignature } from 'lucide-react';
const bonuses = [{
  icon: <CheckSquare className="w-7 h-7" data-id="element-58" />,
  n: 'Bono 1',
  title: 'Checklist Profesional para Casos de Salud',
  desc: 'No olvides ningún documento importante. Organizá la prueba desde el primer día y evitá errores que puedan debilitar el reclamo.',
  value: '$14.990'
}, {
  icon: <Send className="w-7 h-7" data-id="element-59" />,
  n: 'Bono 2',
  title: 'Kit de Reclamos e Intimaciones Listas para Usar',
  desc: 'Modelos editables de reclamos previos, notas a obras sociales, prepagas e intimaciones para actuar con rapidez y profesionalismo.',
  value: '$9.990'
}, {
  icon: <FileSignature className="w-7 h-7" data-id="element-60" />,
  n: 'Bono 3',
  title: 'Plantillas Estratégicas de Cautelares y Amparos',
  desc: 'La estructura profesional detrás de medidas cautelares y acciones de amparo para redactar más rápido y con mayor seguridad jurídica.',
  value: '$7.990'
}];
export const Bonuses = () => {
  return <section className="py-20 bg-legal-900" data-id="element-61">
      <div className="container mx-auto px-4" data-id="element-62">
        <div className="text-center mb-16 max-w-2xl mx-auto" data-id="element-63">
          <span className="inline-flex items-center gap-2 text-gold-500 font-semibold tracking-widest uppercase text-sm mb-4" data-id="element-64">
            <Gift className="w-4 h-4" data-id="element-65" />
            Bonos exclusivos
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-66">
            Además, te llevás 3 bonos profesionales sin costo
          </h2>
          <p className="text-slate-400 text-lg" data-id="element-67">
            Herramientas listas para usar que aceleran tu trabajo desde el
            primer caso.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto mb-12" data-id="element-68">
          {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="relative bg-legal-800 border border-gold-500/30 rounded-xl p-7 flex flex-col hover:border-gold-500/60 transition-colors" data-id="element-69">
              <span className="absolute -top-3 left-6 bg-gold-500 text-legal-900 text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full" data-id="element-70">
                {bonus.n}
              </span>

              <div className="mb-5 mt-2 flex items-center justify-center w-14 h-14 rounded-lg bg-gold-500/10 text-gold-500" data-id="element-71">
                {bonus.icon}
              </div>

              <h3 className="text-lg font-bold text-white mb-3 leading-snug" data-id="element-72">
                {bonus.title}
              </h3>
              <p className="text-slate-400 leading-relaxed mb-6 flex-1" data-id="element-73">
                {bonus.desc}
              </p>

              <div className="flex items-center justify-between border-t border-legal-700 pt-4" data-id="element-74">
                <span className="text-sm text-slate-400" data-id="element-75">Valor</span>
                <span className="font-bold text-white line-through decoration-gold-500/70 decoration-2" data-id="element-76">
                  {bonus.value}
                </span>
              </div>
            </motion.div>)}
        </div>

        {/* Value stack */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="max-w-xl mx-auto text-center bg-legal-800 border border-legal-700 rounded-2xl p-6" data-id="element-77">
          <p className="text-slate-400 mb-1" data-id="element-78">Valor total de los bonos</p>
          <p className="font-serif text-3xl font-bold text-white" data-id="element-79">
            <span className="line-through decoration-gold-500 decoration-2 text-slate-500" data-id="element-80">
              $32.970
            </span>{' '}
            <span className="text-gold-500" data-id="element-81">incluidos hoy</span>
          </p>
          <p className="text-sm text-slate-400 mt-2" data-id="element-82">
            Los 3 bonos están incluidos sin cargo al adquirir el Tratado.
          </p>
        </motion.div>
      </div>
    </section>;
};